<div class="tabspl">
    <div class="tabrow">
        <div class="clearfix"></div>
        <div class="col-12 f-search-wrap">
            <form [formGroup]="regConfig">
                <div class="row">
                    <div class="col-md-12 col-12 nopad">
                        <div class="valign-wrapper field-outer ai-fs nav">
                            <div class="col-md-6 col-12 padrt10 form-group">
                                <label class="bold fs-18">
                                    Location / City
                                </label>
                                <input placeholder="Location / City" type="text" class="validate text-capitalize searchinput nrm_input"
                                    (keyup)="getAutoCompleteLocations($event)" for="dynmicLocations" (click)="openCity()"
                                    formControlName="cityName"     (focusout)="validateLocation(destination_name.value)"
                                    (input)="resetValidLocation()"
                                    [ngStyle]="{'background': isLoading ? 'url(./assets/images/loader-inp.gif) no-repeat scroll 98% center #eeeeee' : '' }"
                                    #destination_name>
                                <small class="invalid-feedback" style="display: block;"
                                    *ngIf="hasError('cityName', 'required');">
                                 Location/City is required* </small>
                                <ul class="droplocations" id="dynmicLocations" *ngIf="!mobileFrom">
                                    <li *ngFor="let location of locations" (click)="selectedLocation(location)">
                                        {{location.cityName +' ('+
                                        location.countryCode +')'}}</li>
                                </ul>

                                <div class="open_city" *ngIf="mobileFrom">
                                    <div class="mobile-input-header">
                                        <div class="mobile-input-icon" (click)="onCloseLocation()"><i class="fal fa-arrow-left"></i></div>
                                        <div class="mobile-input-title">Where are you Going</div>
                                    </div>
                                    <label for="departureCity">Location / City</label>
                                    <input placeholder="Location / City" type="text" class="validate text-capitalize searchinput nrm_input"
                                    (keyup)="getAutoCompleteLocations($event)" for="dynmicLocations"
                                    formControlName="cityName"
                                    [ngStyle]="{'background': isLoading ? 'url(./assets/images/loader-inp.gif) no-repeat scroll 98% center #eeeeee' : '' }"
                                    #destination_name>
    
                                    <ul class="droplocations" id="dynmicLocations">
                                        <li *ngFor="let location of locations" (click)="selectedLocation(location)">
                                            {{location.cityName +' ('+
                                            location.countryCode +')'}}</li>
                                    </ul>
    
                                    <div class="mobile-input-footer">
                                        <div class="cancel_btn" (click)="onCloseLocation()">Cancel</div>
                                    </div>
                                </div>

                            </div>
                            <div class="col-md-3 col-12 padrt10 form-group" id="">
                                <label class="bold fs-18">Check In</label>
                                <span class="micon"></span>
                                <input type="text" id="checkin" formControlName="checkin"
                                    class="validate datepick searchinput nrm_input" placement="bottom left"
                                    placeholder="Select Date" bsDatepicker [bsConfig]="bsDateConf" [readonly]="true"
                                    (ngModelChange)="onCheckIn($event)" [minDate]="minDate" [isOpen]="isOpen"
                                    #checkinDate>
                                <small class="invalid-feedback" style="display: block;"
                                    *ngIf="hasError('checkin', 'required');">
                                 Check In Date is required* </small>
                            </div>
                            <div class="col-md-3 col-12 padrt10 form-group" id="">
                                <label class="bold fs-18">Check Out</label>
                                <span class="micon"></span>
                                <input type="text" id="return" formControlName="checkout"
                                    class="validate datepick round-trip searchinput nrm_input" placement="bottom left"
                                    placeholder="Select Date" bsDatepicker [bsConfig]="bsDateConf"
                                    (ngModelChange)="onCheckOut($event)" [isOpen]="isOpen"
                                    [minDate]="regConfig.controls.checkin.value || setMinDate" [readonly]="true"
                                    [isDisabled]="regConfig.controls.checkin.value ? false : true" #checkoutDate>

                                <small class="invalid-feedback" style="display: block;"
                                    *ngIf="hasError('checkout', 'required');">
                                    Check Out Date is required* </small>
                            </div>
                            <small class="invalid-feedback" style="display: block;"
                            *ngIf="validationMsg"> {{validationMsg}} </small>
                        </div>
                    </div>
                    <!-- start traveller -->
                    <div class="col-md-12 col-12 nopad">
                        <div class="valign-wrapper field-outer ai-fs">
                            <div class="col-md-6 padrt10 form-group">
                                <label class="bold fs-18">Travelers</label>
                                <div class="dropdown" novalidate (validSubmit)="onSubmitTraveller()">
                                    <div class="traveller-input tp2 valign-wrapper fs-18 ">
                                        <span class="remngwd nrm_input" (click)="travellersFadeinn=!travellersFadeinn">
                                            <span class="total_pax_count">
                                                <span id="travel_text"> {{noOfRooms}} Room,</span>
                                                <span id="travel_text"> {{noOfAdults}} Adult</span>
                                                <span id="travel_text" *ngIf="noOfChild > 0">, {{noOfChild}}
                                                    Child</span>
                                                &nbsp;
                                            </span>
                                        </span>
                                        <div class="roomcount pax_count_div {{travellersFadeinn ? 'fadeinn' : ''}}"
                                            *ngIf="travellersFadeinn">

                                            <div class="inallsn">
                                                <div #myDetails class="lablform2 mobilelabel_trv" (click)="closeTravellers()"><i class="fas fa-arrow-left"></i>
                                                    Travellers</div>
                                                <ng-container formArrayName="traveller">
                                                    <ng-container
                                                        *ngFor="let item of regConfig.get('traveller')['controls']; index as i"
                                                        [formGroupName]="i">
                                                        <div class="oneroom fltravlr pb-0">
                                                            <div #myDetails class="lablform2">
                                                                Room {{i+1}}
                                                            </div>
                                                            <div class="clearfix"></div>
                                                            <div class="roomrow">
                                                                <div class="celroe col-md-7 col-7">
                                                                    <i class="fa fa-male"></i> Adults
                                                                    <span class="agemns">(12+ yrs)</span>
                                                                </div>
                                                                <div class="celroe col-md-5 col-5">
                                                                    <div
                                                                        class="input-group countmore pax-count-wrapper adult_count_div">
                                                                        <span class="input-group-btn">
                                                                            <button
                                                                                (click)="onUpdateTraveller(i, 'adults', 'minus')"
                                                                                type="button"
                                                                                class="btn btn-default btn-number"
                                                                                data-type="minus" data-field="adult">
                                                                                <span class="fa fa-minus"></span>
                                                                            </button>
                                                                        </span>
                                                                        <input formControlName="adults" type="text"
                                                                            id="OWT_adult" name="adult"
                                                                            class="form-control input-number centertext valid_class pax_count_value"
                                                                            value="1" min="1" max="9" readonly="">
                                                                        <span class="input-group-btn">
                                                                            <button
                                                                                (click)="onUpdateTraveller(i, 'adults', 'plus')"
                                                                                type="button"
                                                                                class="btn btn-default btn-number"
                                                                                data-type="plus" data-field="adult">
                                                                                <span class="fa fa-plus"></span>
                                                                            </button>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="roomrow last">
                                                                <div class="celroe col-md-7 col-7">
                                                                    <i class="fa fa-child"></i> Children
                                                                    <span class="agemns">(2-11 yrs)</span>
                                                                </div>
                                                                <div class="celroe col-md-5 col-5">
                                                                    <div
                                                                        class="input-group countmore pax-count-wrapper child_count_div">
                                                                        <span class="input-group-btn">
                                                                            <button
                                                                                (click)="onUpdateTraveller(i, 'childrens', 'minus')"
                                                                                type="button"
                                                                                class="btn btn-default btn-number"
                                                                                data-type="minus" data-field="child">
                                                                                <span class="fa fa-minus"></span>
                                                                            </button>
                                                                        </span>
                                                                        <input formControlName="childrens" type="text"
                                                                            id="OWT_child" name="child"
                                                                            class="form-control input-number centertext pax_count_value"
                                                                            value="0" min="0" max="9" readonly="">
                                                                        <span class="input-group-btn">
                                                                            <button
                                                                                (click)="onUpdateTraveller(i, 'childrens', 'plus')"
                                                                                type="button"
                                                                                class="btn btn-default btn-number"
                                                                                data-type="plus" data-field="child">
                                                                                <span class="fa fa-plus"></span>
                                                                            </button>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="chilagediv" *ngIf="noOfChild>0" formArrayName="childAges">
                                                                <div class="row">
                                                                    <div class="col-xl-12 chldrnage" *ngIf="getAge(i).controls.length > 0">Children's ages at time of travel</div>
                                                                    <ng-container *ngFor="let age of getAge(i).controls; let ageIndex=index">
                                                                        <div class="col-xl-6 child-age-wrapper-1">
                                                                            <div class="mrgnpadd" [formGroupName]="ageIndex">
                                                                                <div class="plcetogo selctmarksml">
                                                                                    <select name="childAge_1[]" (change)="onChange($event.target.value,i,ageIndex)"
                                                                                        class="normalsel padselctsmal arimo" formControlName="childAge">
                                                                                        <option *ngFor="let num of [2, 3, 4, 5, 6, 7, 8, 9, 10, 11]" [value]="num"
                                                                                            [selected]="num === 2">{{ num }}</option>
                                                                                    </select>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </ng-container>
                                                                </div>
                                                            </div>
                                                            <button *ngIf="noOfRooms < 3 && (noOfRooms - 1 == i || noOfRooms - 1 == 3)"
                                                                class="add_rooms comnbtn_room" style="display: block;"
                                                                (click)="addRoom()">
                                                                <i class="fa fa-plus-circle"></i>&nbsp;Add room
                                                            </button>
                                                            <button *ngIf="noOfRooms-1 == i+1"
                                                                class="add_rooms comnbtn_room" style="display: block;"
                                                                (click)="removeRoom(i)">
                                                                <i class="fa fa-plus-circle"></i>&nbsp;Remove room
                                                            </button>

                                                            <div class="clearfix"></div>

                                                            <button style="float:right; margin-bottom:10px;"
                                                                *ngIf="noOfRooms-1 == i" (click)="closeTravellers()"
                                                                class="btn btn-success">OK</button>
                                                        </div>

                                                    </ng-container>
                                                </ng-container>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-12 padrt10" *ngIf="countries">
                                <div class="form-group">
                                    <label class="bold fs-18">Nationality</label>
                                    <select formControlName="market" class="form-control searchinput form-control-sm nrm_input">
                                        <option *ngFor="let c of countries" [value]="c?.code">
                                            {{c?.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3 nopad">
                                <!-- <label class="bold fs-18">
                                    &nbsp;
                                </label> -->
                                <div class="all-btn shwroombtn">
                                    <button class="waves-effect btn w-100" type="submit" (click)="onSubmit()">Search Hotels</button>
                                </div>
                            </div>
                         </div>
                    </div>
                    <!-- end traveller -->
                    <div class="col-md-12 col-12 nopad">
                        <div>
                            <a class="btn btn-primary advanopt" (click)="isCollapsed = !isCollapsed" role="button" aria-expanded="false" aria-controls="collapseExample">
                                Advance Filters
                            </a>
                        </div>
                        <div [collapse]="!isCollapsed">
                            <div class="card card-body">
                                <div class="row">
                                    <!-- Star Rating Filter -->
                                    <div class="col-md-4 form-group mb-0 mt-3">
                                        <div class="padrt10">
                                            <p class="bold fs-12">Star Rating</p>
                                            <ngb-rating [max]="5" [(rate)]="starRating"></ngb-rating>
                                        </div>
                                    </div>
                                    <!-- Price Range Slider -->
                                    <div class="col-md-4 form-group mb-0 mt-3">
                                        <div class="padrt10">
                                            <p class="bold fs-12">Price Range</p>
                                            <ngx-slider [(value)]="minValue" [(highValue)]="maxValue" [options]="options"
                                                (valueChange)="valueChange($event)"
                                                (highValueChange)="highValueChange($event)"></ngx-slider>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                      

                </div>
            </form>
        </div>
    </div>
</div>